import { Toast } from 'mint-ui'

// 普通提示
export function toast (msg, second) {
  return Toast({
    message: msg,
    position: 'middle',
    duration: second || 2000
  })
}

// 操作成功提示
export function toastSuc (msg, second) {
  return Toast({
    message: msg,
    iconClass: 'icon icon-success',
    duration: second || 2000
  })
}

// 底部普通提示
export function toastB (msg, second) {
  return Toast({
    message: msg,
    position: 'bottom',
    duration: second || 2000
  })
}



// WEBPACK FOOTER //
// ./src/utils/toast.js